import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { AbntPipe } from '@shared/pipes/abnt.pipe';
import { UtilService } from '../../../../../shared/services/util.service';

@Component({
  selector: 'app-servico-tomado-totais',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, AbntPipe],
  templateUrl: './servico-tomado-totais.component.html',
  styleUrl: './servico-tomado-totais.component.css',
})
export class ServicoTomadoTotaisComponent {
  @Input({ required: true }) form!: FormGroup;

  public get valorTotal(): number {
    return Number(this.form.get('valorTotal')?.value) || 0;
  }

  public get valorLiquido(): number {
    return Number(this.form.get('valorLiquido')?.value) || 0;
  }

  public get totalImpostosRetidos(): number {
    return UtilService.arredondarAbnt(this.valorTotal - this.valorLiquido, 2);
  }
}
